<aside class="sidebar" [class.sidebar--collapsed]="collapsed">
  <div class="sidebar__brand">
    <img
      src="assets/images/authentication/nea-logo.png"
      alt="Nepal Electricity Authority Logo"
      class="sidebar__logo"
    />
    @if (!collapsed) {
      <div class="sidebar__brand-copy">
        <h2>Nepal LDC</h2>
        <p>PSOD Portal</p>
      </div>
    }
  </div>

  <nav class="sidebar__nav" aria-label="Dashboard navigation">
    @for (item of items(); track trackById($index, item)) {
      <div class="sidebar__group">
        @if (item.children.length > 0) {
          <button
            type="button"
            class="sidebar__item sidebar__item--group"
            [class.sidebar__item--active]="isActive(item)"
            (click)="handleItemClick(item)"
            [title]="collapsed ? item.label : ''"
          >
            <i class="sidebar__fa fa-solid" [ngClass]="item.iconClass" aria-hidden="true"></i>
            @if (!collapsed) {
              <span class="sidebar__label">{{ item.label }}</span>
              <span class="sidebar__caret">{{ isOpen(item.id) ? '▾' : '▸' }}</span>
            }
          </button>

          @if (isOpen(item.id) && !collapsed) {
            <div class="sidebar__children">
              @for (child of item.children; track trackById($index, child)) {
                <button
                  type="button"
                  class="sidebar__child"
                  [class.sidebar__child--active]="isActive(child)"
                  (click)="handleItemClick(child)"
                >
                  <i class="sidebar__fa sidebar__fa--child fa-solid" [ngClass]="child.iconClass" aria-hidden="true"></i>
                  <span class="sidebar__child-label">{{ child.label }}</span>
                </button>
              }
            </div>
          }
        } @else {
          <button
            type="button"
            class="sidebar__item"
            [class.sidebar__item--active]="isActive(item)"
            (click)="handleItemClick(item)"
            [title]="collapsed ? item.label : ''"
          >
            <i class="sidebar__fa fa-solid" [ngClass]="item.iconClass" aria-hidden="true"></i>
            @if (!collapsed) {
              <span class="sidebar__label">{{ item.label }}</span>
            }
          </button>
        }
      </div>
    }
  </nav>

  @if (!collapsed) {
    <div class="sidebar__footer">
      <div class="sidebar__support">
        <p class="sidebar__support-title">Need Help?</p>
        <p class="sidebar__support-copy">Contact our support team for assistance</p>
        <button type="button" class="sidebar__support-action">Get Support</button>
      </div>
    </div>
  }
</aside>
